// Back buttons on tracker pages return to the page that opened them (a tracker tab, a list with
// its filters, a submission…) together with that page's own Back target. Opened from a link or
// after a refresh, they fall back to their usual place.

/** navigate() state that makes the opened page's Back return here (URL + this page's state). */
export const withBack = () => ({
  backTo: `${window.location.pathname}${window.location.search}`,
  backState: window.history.state?.usr ?? null,
});

const BACK_LABELS = [
  [/^\/tracker-submissions\/[^/?]+/, "Back to submission"],
  [/^\/tracker-submissions/, "Back to submissions"],
  [/^\/tracker-reviews\/[^/?]+/, "Back to review"],
  [/^\/tracker-reviews/, "Back to reviews"],
  [/^\/trackers\/[^/?]+/, "Back to tracker"],
  [/^\/trackers/, "Back to trackers"],
  [/^\/dashboard/, "Back to dashboard"],
];

/** This page's Back: `{ to, label, go }` — the page that opened it, else `fallback`. */
export const backTarget = (location, navigate, fallback, fallbackLabel) => {
  const to = location.state?.backTo;
  if (!to) {
    return { to: fallback, label: fallbackLabel, go: () => navigate(fallback) };
  }
  const hit = BACK_LABELS.find(([pattern]) => pattern.test(to));
  return {
    to,
    label: hit ? hit[1] : "Back",
    go: () => navigate(to, { state: location.state?.backState ?? undefined }),
  };
};
